import axios, {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
  AxiosError,
} from "axios";

const axiosConfig = {
  baseURL: "https://radar.tlpservicos.com.br/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
};

const api: AxiosInstance = axios.create(axiosConfig);

const getAuthToken = (): string | null => {
  return localStorage.getItem("authToken");
};

let navigateFunction: ((to: string) => void) | null = null;

export const setupNavigation = (navFunc: (to: string) => void) => {
  navigateFunction = navFunc;
};

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (!config.url?.endsWith("/login")) {
      const token = getAuthToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error: AxiosError): Promise<AxiosError> => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  (error: AxiosError): Promise<AxiosError> => {
    if (error.response) {
      console.error("Erro na resposta:", error.response.data);
      if (error.response.status === 401 && navigateFunction) {
        localStorage.removeItem("authToken");
        navigateFunction("/login");
      }
    } else if (error.request) {
      console.error("Erro na requisição:", error.request);
    } else {
      console.error("Erro:", error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
